import { render, staticRenderFns } from "./card_flights_count.vue?vue&type=template&id=7a0a8410&scoped=true"
import script from "./card_flights_count.vue?vue&type=script&lang=js"
export * from "./card_flights_count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0a8410",
  null
  
)

export default component.exports